const { setInitialised, useArrows } = window.BAO.Carousel.plugins
const { trapFocus, disableTrapFocus } = window.BAO.Utils

class GalleryCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()

    this.activeIndex = null
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    document.addEventListener('click', this.handleTrigger)

    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(this.els.close.element, 'click', this.handleClose)
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('util-SiteOverflowed')

    disableTrapFocus()

    document.documentElement.removeEventListener(
      'keydown',
      this.handleKeydown.bind(this),
    )

    const relativeTrigger = this.externalEls?.trigger?.elements.find(
      (el) => el.dataset.index === String(this.activeIndex),
    )

    if (relativeTrigger) relativeTrigger.focus()

    this.activeIndex = null
  }

  handleTrigger (event) {
    if (!event.target.closest(this.externalEls?.trigger?.selector)) return

    const counter = parseInt(event.target.dataset.index, 10)

    this.activeIndex = counter

    this.els.title.element.textContent = event.target.dataset.title

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')

    if (this.carousel) {
      this.carousel.update()

      this.carousel.moveToIdx(counter, false, { duration: 0 })

      this.els.close.element?.focus()

      trapFocus(this)
    }

    document.documentElement.addEventListener(
      'keydown',
      this.handleKeydown.bind(this),
    )
  }

  setupCarousel () {
    const slider = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )

    slider.on('slideChanged', (e) => {
      this.updateTitle(slider)
      this.activeIndex = e.track.details.abs
    })

    return slider
  }

  updateTitle (slider) {
    const activeSlideIndex = slider.track.details.rel

    const activeSlide = this.els.slides.element.querySelector(
      `${this.els.slide.selector}:nth-child(${activeSlideIndex + 1})`,
    )

    if (activeSlide?.dataset.title) {
      this.els.title.element.textContent = activeSlide.dataset.title
    }
  }

  handleKeydown (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.handleClose()
    }
  }
}

if (!customElements.get('gallery-carousel')) {
  customElements.define('gallery-carousel', GalleryCarousel)
}
